import OpenTabsIcon from '@/features/openTabs/icons/OpenTabsIcon'
import DeliveryTypeInfo from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/DeliveryTypeInfo'
import InfoRow from '@/features/orders/components/OrderListItem/parts/OrderMetaInfo/parts/InfoRow'
import { deliveryTypeIconMap } from '@/features/orders/components/OrderListItem/utils/iconMaps'
import { Channel } from '@/features/orders/constants/app'
import { Order } from '@/features/orders/types/app'
import { FC } from 'react'

interface DeliveryTypeRowProps {
    channel: Order['channel']
    deliveryTypeCategory?: Order['deliveryType']['typeCategory']
    customerName?: Order['customerName']
    deliveryAddress?: Order['deliveryAddress']
}

const DeliveryTypeRow: FC<DeliveryTypeRowProps> = ({
    channel,
    deliveryTypeCategory,
    customerName,
    deliveryAddress,
}) => {
    const Icon =
        channel === Channel.Tab
            ? OpenTabsIcon
            : deliveryTypeCategory
              ? deliveryTypeIconMap[deliveryTypeCategory]
              : undefined

    if (!Icon) return null

    return (
        <InfoRow
            Icon={Icon}
            content={
                <DeliveryTypeInfo customerName={customerName} deliveryAddress={deliveryAddress} />
            }
        />
    )
}

export default DeliveryTypeRow
